import interceptor, { baseUrl } from '../common/interceptor';
import axios from 'axios';
import { getUserTimeZone } from '@/common/interceptor/interceptor';
import { APIPaths } from '../common/constants';
import { ApiResponse } from '@/apis/types';
import {
  GetReportScheduleListResponse,
  GetSingleReportScheduleResponse,
} from '@/pages/Data/types';
import { OperationType } from '@/common/enum';
import type { UserTaskData } from '@/pages/HomeV2/types';
// These annotate the legacy-Home functions below, whose payload shapes HomeV2
// has since changed -- so they come from a frozen copy rather than either tree.
import type {
  HomeReportsLayoutResponseData,
  HomeReportsDrilldownPayload,
  HomeReportsDrilldownResponseData,
  HomeReportsOperationalDriversSummaryPayload,
  HomeReportsOperationalDriversSummaryResponseData,
  HomeReportsCostBreakdownSummaryPayload,
  HomeReportsCostBreakdownSummaryResponseData,
  HomeReportsVolumeBreakdownSummaryPayload,
  HomeReportsVolumeBreakdownSummaryResponseData,
  HomeReportsSectionDownloadPayload,
  HomeReportsSectionsDataResponseData,
  HomeReportsSectionsDataPayload,
  SaveHomeReportsLayoutPayload,
} from './legacyHomeReports.types';

// API call for home page USER TASKS
export const GetUserTask = (
  token: string
): Promise<ApiResponse<UserTaskData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.button_status, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};
// API call for shipment chart
export const GetShipmentChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.shipment_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Shipment Chart:', error?.response);
        reject(error?.response);
      });
  });
};
export const GetCycleTimeChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.cycle_time_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Shipment Chart:', error?.response);
        reject(error?.response);
      });
  });
};

// API call for Right time  chart [mahtab]
export const GetRightTimeChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.right_Time_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Shipment Chart:', error?.response);
        reject(error?.response);
      });
  });
};

// API call for shipment chart [mahtab]
export const GetAverageTimeChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.average_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Shipment Chart:', error?.response);
        reject(error?.response);
      });
  });
};
// API call for Dwell Time chart [mahtab]
export const GetDwellTimeChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.dwell_Time_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Dwell Time Chart:', error?.response);
        reject(error?.response);
      });
  });
};

// API call for on time chart
export const GetOntimeChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.ontime_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Ontime delivery Chart:', error?.response);
        reject(error?.response);
      });
  });
};

// API call for on time pickup chart
export const GetOntimePickupChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.ontime_pickup_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Ontime Pickup Chart:', error?.response);
        reject(error?.response);
      });
  });
};

// API call for schedule adherence chart
export const GetScheduleAdherenceChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.schedule_adherence_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error(
          'Error fetching Schedule Adherence Chart:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

// API call for delivery exception chart
export const GetDeliveryExceptionChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.delivery_exception_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error(
          'Error fetching delivery exception Chart:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

// API call for invoice disputes chart
export const GetInvoiceDisputesChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.invoice_disputes_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error(
          'Error fetching Invoice Disputes Chart:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

// API call for cost chart
export const GetCostChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.cost_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Cost Chart:', error?.response);
        reject(error?.response);
      });
  });
};

export const GetFreightMarkupChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.freight_markup_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Freight Markup Chart:', error?.response);
        reject(error?.response);
      });
  });
};

export const GetSkuVolumeChart = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.sku_volume_chart,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching SKU Volume Chart:', error?.response);
        reject(error?.response);
      });
  });
};

export const GetSkuVolumeTrend = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.sku_volume_trend,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching SKU Volume Trend:', error?.response);
        reject(error?.response);
      });
  });
};

/** The cells a stream is limited to: the grid level and the cell ids to send. */
export interface StreamCellFilter {
  level: number;
  cellIds: readonly number[];
}

/**
 * Builds the URL of the shipment location stream. This is the one place the app
 * opens an `EventSource` instead of calling `interceptor`: `EventSource` cannot
 * send an Authorization header, so the token goes in the query string (the
 * backend reads it the same way for every stream client).
 *
 * `cells` limits the stream to those cells (`level` and `cell_ids`, which the
 * backend requires together).
 */
export const buildStreamShipmentUrl = (
  token: string,
  query = '',
  size?: number,
  cells?: StreamCellFilter
): string => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  let url = `${baseURL}api/shipment/stream-shipment-locations/?token=${token}`;
  if (query) {
    url += `&${query}`;
  }
  if (size) {
    url += `&size=${size}`;
  }
  if (cells) {
    url += `&level=${cells.level}&cell_ids=${cells.cellIds.join(',')}`;
  }
  return url;
};

/** Per-attempt budget of a home map request; `axiosGet` retries a timed-out attempt 3 times. */
export const HOME_MAP_REQUEST_TIMEOUT_MS = 5000;

/**
 * One grid cell, as `[x, y, count, with_alerts, critical, avg_lat, avg_lon]`.
 * Mirrors `CellField` in `backend/shipment/home_map/serializer/home_map_query.py`.
 */
export type HomeMapCell = readonly [
  x: number,
  y: number,
  count: number,
  withAlerts: number,
  critical: number,
  avgLat: number,
  avgLon: number,
];

/**
 * Shipment counts of a scope. Mirrors `TotalsSerializer` in
 * `backend/shipment/home_map/serializer/home_map_query.py`.
 */
export interface HomeMapTotals {
  active: number;
  located: number;
  unlocated: number;
  critical: number;
  at_risk: number;
}

/**
 * One of the most urgent shipments of a scope. Mirrors `NeedsAttentionSerializer`
 * in `backend/shipment/home_map/serializer/home_map_query.py`;
 * `severity` is `critical` or `at_risk` (`Attention` in
 * `backend/shipment/home_map/domain/cells.py`).
 */
export interface HomeMapNeedsAttention {
  id: string;
  reference: string;
  severity: 'critical' | 'at_risk';
}

/**
 * Body of `GET /api/v1/home-map/overview/`. Mirrors `OverviewSerializer` in
 * `backend/shipment/home_map/serializer/home_map_query.py`.
 * `level6` is absent when `stream_all` is true; `bounds` is
 * `[west, south, east, north]` or null when the scope has no located shipment.
 */
export interface HomeMapOverview {
  as_of: string;
  totals: HomeMapTotals;
  stream_all: boolean;
  limits: { stream_budget: number };
  bounds: [number, number, number, number] | null;
  level6?: HomeMapCell[];
  needs_attention: HomeMapNeedsAttention[];
}

/**
 * Body of `GET /api/v1/home-map/cells/`. Mirrors `CellsSerializer` in
 * `backend/shipment/home_map/serializer/home_map_query.py`;
 * `expand` lists the ids of the cells the client streams.
 */
export interface HomeMapCells {
  level: number;
  as_of: string;
  cells: HomeMapCell[];
  expand: number[];
}

/** The viewport of a cells request, in degrees: west, south, east, north. */
export type HomeMapBbox = readonly [
  west: number,
  south: number,
  east: number,
  north: number,
];

/** Parameters of `getHomeMapCells`; `filterQuery` is the stream's encoded filter string. */
export interface HomeMapCellsParams {
  level: number;
  bbox: HomeMapBbox;
  filterQuery?: string;
}

const joinQuery = (...parts: string[]): string =>
  parts.filter(Boolean).join('&');

/**
 * Fetches the home map overview of the current scope and filters (cached by the
 * backend for 5 min). Rejects without a toast: the map shows its own Degraded
 * state.
 */
export const getHomeMapOverview = async (
  filterQuery = '',
  signal?: AbortSignal
): Promise<HomeMapOverview> => {
  const path = `/v1/home-map/overview/${filterQuery ? `?${filterQuery}` : ''}`;
  const response = await interceptor.axiosGet(
    'Get',
    path,
    undefined,
    undefined,
    signal,
    true,
    HOME_MAP_REQUEST_TIMEOUT_MS
  );
  return response.data as HomeMapOverview;
};

/**
 * Fetches the grid cells of one viewport at one level, and the ids of the cells
 * to stream. Rejects without a toast: the map shows its own Degraded state.
 */
export const getHomeMapCells = async (
  { level, bbox, filterQuery = '' }: HomeMapCellsParams,
  signal?: AbortSignal
): Promise<HomeMapCells> => {
  const query = joinQuery(
    `level=${level}`,
    `bbox=${bbox.join(',')}`,
    filterQuery
  );
  const response = await interceptor.axiosGet(
    'Get',
    `/v1/home-map/cells/?${query}`,
    undefined,
    undefined,
    signal,
    true,
    HOME_MAP_REQUEST_TIMEOUT_MS
  );
  return response.data as HomeMapCells;
};

// get news flash card data

export interface NewsFlashItem {
  id: string;
  title: string;
  message: string;
  category?: string;
  primary_hazard?: string | null;
  relative_created_at?: string;
  created_at?: string;
  user_rating?: 'thumbs_up' | 'thumbs_down' | null;
  polygons?: unknown[];
  title_without_date?: string;
}

type GetNewsFlashResponse = ApiResponse<NewsFlashItem[]>;

export const GetNewsFlash = (token: string): Promise<GetNewsFlashResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.home_news_flash, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('error fetching news flash', error?.response);
        reject(error?.response);
      });
  });
};

export interface NewsFlashFeedbackResponseData {
  newsflash_id: string;
  rating: 'thumbs_up' | 'thumbs_down';
  updated_at?: string;
  created_at?: string;
}

type SubmitNewsFlashFeedbackResponse =
  ApiResponse<NewsFlashFeedbackResponseData>;

export const SubmitNewsFlashFeedback = (
  token: string,
  newsflashId: string,
  rating: 'thumbs_up' | 'thumbs_down'
): Promise<SubmitNewsFlashFeedbackResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        `/auth/newsflash/${newsflashId}/feedback/`,
        { rating },
        token
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('error submitting news flash feedback', error?.response);
        reject(error?.response);
      });
  });
};

// API call for add/edit metrics [mahtab]
export interface MetricModel {
  /** Backend stores integers; form/UI may use strings temporarily. */
  on_time_window_value?: string | number;
  on_time_window_unit?: string;
  include_early_as_on_time?: boolean;
  distribution_granularity_value?: number;
  distribution_granularity_unit?: string;
  target_key: string | null;
  target_value?: number;
  shipment_target_time_period?: string;
  airport_disruption_regions?: string[];
  [key: string]: unknown;
}
export interface EditChartsModel {
  id?: string;
  label?: string;
  enabled?: boolean;
  order?: number;
}

interface SendMetricsResponseData {
  shipment_traget_matric?: number | string;
  on_time_delivery_target?: number | string;
  median_transit_time_target?: number | string;
  right_first_time_delivery_target?: number | string;
  airport_disruption?: number;
  airport_disruption_regions?: string[];
}

type SendMetricsAPIResponse = ApiResponse<SendMetricsResponseData>;

export const sendtMetrics = (
  token: string,
  model: MetricModel
): Promise<SendMetricsAPIResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.home_target_metrics, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error while posting Chart metrics:', error?.response);
        reject(error?.response);
      });
  });
};

// get company targer data
export const getCompnayTargetSettings = (token: string): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', `${APIPaths.home_target_metrics}`, token)
      .then((res) =>
        resolve({
          data: res.data,
          headers: res.headers as Record<string, unknown>,
        })
      )
      .catch((error) => {
        console.error(
          'Error fetching company target settings:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

//Update Team
export const UpdateOnTimeChartSettings = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut('Put', `${APIPaths.on_time_settings}`, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('UpdateTeam Error:', error?.response);
        reject(error?.response);
      });
  });
};
// update on time pickup chart settings
export const UpdateOnTimePickupSettings = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut('Put', `${APIPaths.ontime_pickup_chart}`, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('UpdateTeam Error:', error?.response);
        reject(error?.response);
      });
  });
};

// update schedule adherence chart settings
export const UpdateScheduleAdherenceSettings = (
  token: string,
  model: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut('Put', `${APIPaths.schedule_adherence_chart}`, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'UpdateScheduleAdherenceSettings Error:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

// API call for Right time  chart [mahtab]

export interface FilterArrayItem {
  filterBy: string;
  filterValue: string[];
}

export interface AppliedFilterItem {
  id: string;
  name: string;
  filterBy: string;
  groupTitle?: string;
  title?: string;
}

export interface ReportFiltersBody {
  name: string;
  filters: {
    filterArray: FilterArrayItem[];
    appliedFilters: AppliedFilterItem[];
  };
}

export interface ReportFilterPreset {
  id: string;
  name: string;
  filters: {
    filterArray: FilterArrayItem[];
    appliedFilters: AppliedFilterItem[];
  };
  created_at?: string;
  updated_at?: string;
}

export type SaveReportFiltersResponse = ApiResponse<ReportFilterPreset>;

export const saveReportFilters = (
  token: string,
  body: ReportFiltersBody
): Promise<SaveReportFiltersResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.shipment_report_filters, body, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error saving report filters:', error?.response);
        reject(error?.response);
      });
  });
};
export const updateReportFilters = (
  token: string,
  id: string,
  body: ReportFiltersBody
): Promise<SaveReportFiltersResponse> => {
  const url = `${APIPaths.shipment_report_filters}${encodeURIComponent(id)}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut('PUT', url, body, token)
      .then(resolve)
      .catch((error) => {
        console.error('Error updating report filters:', error?.response);
        reject(error?.response);
      });
  });
};
export type GetReportFiltersResponse = ApiResponse<ReportFilterPreset[]>;

export const getReportFilters = (
  token: string,
  type: 'report' | 'shipment' = 'report'
): Promise<GetReportFiltersResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet(
        'Get',
        `${APIPaths.shipment_report_filters}?type=${type}`,
        token,
        null
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching report filters:', error?.response);
        reject(error?.response);
      });
  });
};

export type DeleteReportFilterResponse = ApiResponse<null>;

export const deleteReportFilter = (
  token: string,
  id: string
): Promise<DeleteReportFilterResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete(
        'Delete',
        `${APIPaths.shipment_report_filters}${id}/`,
        null,
        token
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error deleting report filter:', error?.response);
        reject(error?.response);
      });
  });
};

export const postReportSchedules = (
  token: string,
  payload: unknown
): Promise<GetReportFiltersResponse> => {
  const url = APIPaths.shipment_report_schedules;

  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', url, payload, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching report filters:', error?.response);
        reject(error?.response);
      });
  });
};

export const updateReportSchedules = (
  token: string,
  payload: unknown,
  id?: string | number | null
): Promise<GetReportFiltersResponse> => {
  const url = id
    ? `${APIPaths.shipment_report_schedules}${id}/`
    : APIPaths.shipment_report_schedules;

  return new Promise((resolve, reject) => {
    interceptor
      .axiosPut('Put', url, payload, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching report filters:', error?.response);
        reject(error?.response);
      });
  });
};

export const getReportSchedulesById = (
  token: string,
  id: string
): Promise<GetSingleReportScheduleResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', `${APIPaths.shipment_report_schedules}${id}/`, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching report filters:', error?.response);
        reject(error?.response);
      });
  });
};

export const getReportSchedulesList = (
  token: string
): Promise<GetReportScheduleListResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', `${APIPaths.shipment_report_schedules}`, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching report filters:', error?.response);
        reject(error?.response);
      });
  });
};

export const deleteReportSchedules = (
  token: string,
  id: string | number
): Promise<GetReportFiltersResponse> => {
  const url = `${APIPaths.shipment_report_schedules}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete('Delete', url, null, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error deleting report schedule:', error?.response);
        reject(error?.response);
      });
  });
};
export const getAvailableHomeShipmetsTabs = (
  token: string,
  conpanionView: boolean = false
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet(
        'Get',
        `${APIPaths.home_companion_shipments_tabs}?companion_view=${conpanionView}`,
        token,
        null
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching home shipment tabs:', error?.response);
        reject(error?.response);
      });
  });
};
// ZD-2579 GET Home KPI filter persistence per user
export const getHomeKpiFilters = (
  token: string
): Promise<ApiResponse<Record<string, unknown> | null>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.home_kpi_filters, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching home KPI filters:', error?.response);
        reject(error?.response);
      });
  });
};
// ZD-2579 POST Home KPI filter persistence per user
export const saveHomeKpiFilters = (
  token: string,
  model: Record<string, unknown>
): Promise<ApiResponse<Record<string, unknown>>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.home_kpi_filters, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error saving home KPI filters:', error?.response);
        reject(error?.response);
      });
  });
};

export type HomeMapFilterVisibility = {
  products: boolean;
  product_type: boolean;
  teams: boolean;
  status: boolean;
  temprature: boolean;
  risk: boolean;
  shipper_rtg: boolean;
  consignee_rtg: boolean;
};

export const DEFAULT_HOME_MAP_FILTER_VISIBILITY: HomeMapFilterVisibility = {
  products: true,
  product_type: true,
  teams: true,
  status: true,
  temprature: true,
  risk: true,
  // Align with BE non-WC defaults (WC GET returns true when enablecustomerleg).
  shipper_rtg: false,
  consignee_rtg: false,
};

// ─── Home KPI filter visibility (which chips show in the toolbar) ─────────────
export type HomeKpiFilterVisibility = {
  transporters: boolean;
  origins: boolean;
  destinations: boolean;
  location_type: boolean;
  products: boolean;
  product_type: boolean;
  temperature: boolean;
  teams: boolean;
  shipper_rtg: boolean;
  consignee_rtg: boolean;
};

export const HOME_KPI_FILTER_VISIBILITY_DEFAULTS: HomeKpiFilterVisibility = {
  transporters: true,
  origins: true,
  destinations: true,
  location_type: false,
  products: true,
  product_type: false,
  temperature: false,
  teams: true,
  shipper_rtg: false,
  consignee_rtg: false,
};

export const getHomeKpiFilterVisibility = (
  token: string
): Promise<ApiResponse<HomeKpiFilterVisibility | null>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.home_kpi_filter_visibility, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error fetching home KPI filter visibility:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const saveHomeKpiFilterVisibility = (
  token: string,
  model: Partial<HomeKpiFilterVisibility>
): Promise<ApiResponse<HomeKpiFilterVisibility>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.home_kpi_filter_visibility, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error saving home KPI filter visibility:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const getHomeMapFilters = (
  token: string
): Promise<ApiResponse<HomeMapFilterVisibility | null>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.home_map_filters, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching home map filters:', error?.response);
        reject(error?.response);
      });
  });
};

export const saveHomeMapFilters = (
  token: string,
  model: Partial<HomeMapFilterVisibility>
): Promise<ApiResponse<HomeMapFilterVisibility>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.home_map_filters, model, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error saving home map filters:', error?.response);
        reject(error?.response);
      });
  });
};

// API call for Dwell Time Locations (ChainOfCustody locations with dwell time events)
export interface DwellTimeLocation {
  name: string;
  shipment_count: number;
  latitude: number | null;
  longitude: number | null;
}

export interface DwellTimeLocationsFilters {
  transporters?: (string | number)[] | HomeFilterSelection;
  products?: (string | number)[] | HomeFilterSelection;
  teams?: (string | number)[] | HomeFilterSelection;
  service_levels?: (string | number)[] | HomeFilterSelection;
  origins?: (string | number)[] | HomeFilterSelection;
  destinations?: (string | number)[] | HomeFilterSelection;
  search?: string;
  start_date?: string;
  end_date?: string;
  period?: string;
}

interface DwellTimeLocationsData {
  locations: DwellTimeLocation[];
}

type GetDwellTimeLocationsResponse = ApiResponse<DwellTimeLocationsData>;

export const GetDwellTimeLocations = (
  token: string | null,
  filters: DwellTimeLocationsFilters
): Promise<GetDwellTimeLocationsResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.dwell_time_locations,
        filters,
        token ?? undefined,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Dwell Time Locations:', error?.response);
        reject(error?.response);
      });
  });
};

interface ChartClickData {
  shipments: { id: string; date: string }[];
  total_pages?: number;
  total_count?: number;
}

type GetChartClickDataResponse = ApiResponse<ChartClickData>;

export const DownloadChartClickData = (token: string, model: unknown) => {
  const method = 'Post';
  const url = APIPaths.download_chart_modal;
  const userTimeZone = getUserTimeZone();
  const requestUrl = `${baseUrl}${url}`;

  return new Promise((resolve, reject) => {
    console.error('Downloading raw data with model:', model);
    axios({
      method: method,
      url: requestUrl,
      data: model,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        timezone: userTimeZone,
      },
      responseType: 'blob',
    })
      .then((res) => {
        console.error('Download response:', {
          status: res.status,
          contentType: res.headers['content-type'],
          blobSize: res.data.size,
          blobType: res.data.type,
        });
        resolve(res);
      })
      .catch((error) => {
        console.error('Download error:', error?.response);
        reject(error?.response);
      });
  });
};

export const GetChartClickData = (
  token: string,
  model: unknown
): Promise<GetChartClickDataResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.chart_click_data,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching Shipment Chart:', error?.response);
        reject(error?.response);
      });
  });
};

export const getHomePermissions = (
  token: string
): Promise<GetReportScheduleListResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', `${APIPaths.home_permissions}`, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching report filters:', error?.response);
        reject(error?.response);
      });
  });
};

export const saveChartsCustomization = (
  token: string,
  model: EditChartsModel[]
): Promise<SendMetricsAPIResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.save_edit_charts, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error while posting Chart settings:', error?.response);
        reject(error?.response);
      });
  });
};

// ─── KPI Side Panel API functions ────────────────────────────────────────────

export const getHomeReportsLayout = (
  token: string
): Promise<ApiResponse<HomeReportsLayoutResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.home_reports_layout, token, null)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching home reports layout:', error?.response);
        reject(error?.response);
      });
  });
};

export const saveHomeReportsLayout = (
  token: string,
  model: SaveHomeReportsLayoutPayload
): Promise<ApiResponse<HomeReportsLayoutResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.home_reports_layout,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error saving home reports layout:', error?.response);
        reject(error?.response);
      });
  });
};

export const getHomeReportsSectionsData = (
  token: string,
  model: HomeReportsSectionsDataPayload
): Promise<ApiResponse<HomeReportsSectionsDataResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.home_reports_sections_data,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error fetching home reports section data:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const getHomeReportsOperationalDriversSummary = (
  token: string,
  model: HomeReportsOperationalDriversSummaryPayload
): Promise<ApiResponse<HomeReportsOperationalDriversSummaryResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.home_reports_operational_drivers_summary,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error fetching home reports operational drivers summary:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const getHomeReportsVolumeBreakdownSummary = (
  token: string,
  model: HomeReportsVolumeBreakdownSummaryPayload
): Promise<ApiResponse<HomeReportsVolumeBreakdownSummaryResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.home_reports_volume_breakdown_summary,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error fetching home reports volume breakdown summary:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const getHomeReportsCostBreakdownSummary = (
  token: string,
  model: HomeReportsCostBreakdownSummaryPayload
): Promise<ApiResponse<HomeReportsCostBreakdownSummaryResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.home_reports_cost_breakdown_summary,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error fetching home reports cost breakdown summary:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const getHomeReportsDrilldown = (
  token: string,
  model: HomeReportsDrilldownPayload
): Promise<ApiResponse<HomeReportsDrilldownResponseData>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.home_reports_drilldown,
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error(
          'Error fetching home reports drilldown:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const downloadHomeReportsDrilldown = (
  token: string,
  model: HomeReportsDrilldownPayload
): Promise<{ data: Blob; headers?: Record<string, unknown> }> => {
  const method = 'Post';
  const url = APIPaths.home_reports_drilldown_download;
  const userTimeZone = getUserTimeZone();
  const requestUrl = `${baseUrl}${url}`;

  return new Promise((resolve, reject) => {
    axios({
      method,
      url: requestUrl,
      data: model,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        timezone: userTimeZone,
      },
      responseType: 'blob',
    })
      .then((res) =>
        resolve({
          data: res.data,
          headers: res.headers as Record<string, unknown>,
        })
      )
      .catch((error) => {
        console.error(
          'Error downloading home reports drilldown:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export const downloadHomeReportsSection = (
  token: string,
  model: HomeReportsSectionDownloadPayload
): Promise<{ data: Blob; headers?: Record<string, unknown> }> => {
  const method = 'Post';
  const url = APIPaths.home_reports_sections_download;
  const userTimeZone = getUserTimeZone();
  const requestUrl = `${baseUrl}${url}`;

  return new Promise((resolve, reject) => {
    axios({
      method,
      url: requestUrl,
      data: model,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        timezone: userTimeZone,
      },
      responseType: 'blob',
    })
      .then((res) =>
        resolve({
          data: res.data,
          headers: res.headers as Record<string, unknown>,
        })
      )
      .catch((error) => {
        console.error(
          'Error downloading home report section:',
          error?.response
        );
        reject(error?.response);
      });
  });
};

export interface DelayReason {
  rank: number;
  reason: string;
  /** Internal normalized key; send as `delay_reason_key` on chart-click drill-down. */
  reason_key?: string;
  count: number;
  color?: string;
}

export interface OtdDelayReasonsData {
  delay_reasons: DelayReason[];
  total_delay_reasons_count?: number;
  total_late_shipments?: number;
  segment_start?: string | null;
  segment_end?: string | null;
}

export type GetOtdDelayReasonsResponse = ApiResponse<OtdDelayReasonsData>;

/** Dashboard-style filter selection: an explicit id list, or "every option"
 *  (select_all: true, values: []). teams may additionally carry an AND/OR
 *  logic flag from the drawer's own Team/Courier refine widget. */
export interface HomeFilterSelection {
  select_all: boolean;
  values: (string | number)[];
  logic?: 'AND' | 'OR';
}

export interface OtdDelayReasonsFilters {
  start_date?: string | null;
  end_date?: string | null;
  date_type?: string;
  transporters?: (string | number)[] | HomeFilterSelection;
  origins?: (string | number)[] | HomeFilterSelection;
  destinations?: (string | number)[] | HomeFilterSelection;
  products?: (string | number)[] | HomeFilterSelection;
  teams?: (string | number)[] | HomeFilterSelection;
  service_levels?: (string | number)[] | HomeFilterSelection;
  limit?: number;
  segment?: string;
  segment_index?: number;
  /** `trend` (default): segment_index is calendar week/month. `distribution`: same scope as OTD distribution drill-down. */
  otd_view?: 'trend' | 'distribution';
  category?: string[];
  stackName?: string;
  visible_categories?: string[];
}

const normalizeDateOnly = (
  value?: string | null
): string | null | undefined => {
  if (value == null || value === '') {
    return value;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toISOString().slice(0, 10);
};

export const GetOtdDelayReasons = (
  token: string | null,
  filters: OtdDelayReasonsFilters
): Promise<GetOtdDelayReasonsResponse> => {
  const payload = {
    ...filters,
    start_date: normalizeDateOnly(filters.start_date),
    end_date: normalizeDateOnly(filters.end_date),
  };

  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.otd_delay_reasons,
        payload,
        token ?? undefined,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching OTD delay reasons:', error?.response);
        reject(error?.response);
      });
  });
};

export interface AlertTrendBucket {
  date: string;
  // Tight display range for the bucket (used for labels / drawer header).
  start_date?: string;
  end_date?: string;
  // Range the bar drill-down should forward to the backend as
  // alert_created_start_date / alert_created_end_date. For middle buckets
  // this equals start_date / end_date. For the first / last bucket the
  // "outside" side is `null` so the drill-down applies a one-sided
  // created_at bound and picks up out-of-window alerts that were clamped
  // into the edge bar on the chart — keeping the drawer "Alerts (N)"
  // header in sync with the bar the user clicked. May be absent when an
  // older backend is in use; callers should fall back to start_date /
  // end_date in that case.
  filter_start_date?: string | null;
  filter_end_date?: string | null;
  open: number;
  resolved: number;
  dismissed: number;
}

export interface AlertTopTeam {
  team_name: string;
  count: number;
  open?: number;
  dismissed?: number;
  resolved?: number;
}

export interface AlertsInsightsData {
  trend: AlertTrendBucket[];
  top_teams: AlertTopTeam[];
}

export type GetAlertsInsightsResponse = ApiResponse<AlertsInsightsData>;

export interface AlertsInsightsFilters {
  alert_type?: string;
  start_date?: string | null;
  end_date?: string | null;
  date_type?: string;
  dates?: string[]; // New field for date range
  segment?: string;
  transporters?: (string | number)[] | HomeFilterSelection;
  origins?: (string | number)[] | HomeFilterSelection;
  destinations?: (string | number)[] | HomeFilterSelection;
  products?: (string | number)[] | HomeFilterSelection;
  teams?: (string | number)[] | HomeFilterSelection;
  service_levels?: (string | number)[] | HomeFilterSelection;
  top_teams_limit?: number;
}

export const GetAlertsInsights = (
  token: string | null,
  filters: AlertsInsightsFilters
): Promise<GetAlertsInsightsResponse> => {
  const payload = {
    ...filters,
    start_date: normalizeDateOnly(filters.start_date),
    end_date: normalizeDateOnly(filters.end_date),
  };

  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.alerts_insights,
        payload,
        token ?? undefined,
        null,
        OperationType.Read
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error('Error fetching alerts insights:', error?.response);
        reject(error?.response);
      });
  });
};
